import { Fitter, LocationData } from '@sc/data-access-models';

export interface ItineraryInputData {
  userAddress: LocationData;
  fitter: Fitter;
}
